/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetReleasePoliciesPathParams = NonNullable<operations['GetReleasePolicies']['parameters']['path']>;

export type GetReleasePoliciesQueryParams = NonNullable<operations['GetReleasePolicies']['parameters']['query']>;

export interface Input extends GetReleasePoliciesPathParams {
  apiVersion?: string;
  query?: GetReleasePoliciesQueryParams;
  header: NonNullable<operations['GetReleasePolicies']['parameters']['header']>;
}

export async function GetReleasePolicies(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/release-policies', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
